import React, { FC } from 'react';
import { media } from 'src/styles/designs';
import styled from 'styled-components';
import { dirRTL, fromTheme } from 'src/styles/theme';
import { useTranslate } from 'react-t7e';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';

const Needle = styled.div`
  background-color: ${fromTheme((theme) => theme.text.palette.accent)};
  position: absolute;
  top: 27px;
  bottom: 35px;
  clip-path: polygon(0 0, 40% 0, 100% 100%, 95% 100%);
  left: -64px;
  width: 37px;
  max-width: 37px;
  max-height: 164px;

  ${media.w.greaterThanOrEqual.desktop} {
    top: 27px;
    bottom: 9px;
    left: -83px;
    width: 41px;
    max-width: 41px;
    max-height: 184px;
  }

  ${dirRTL} {
    left: auto;
    right: -64px;
    clip-path: polygon(60% 0, 100% 0, 5% 100%, 0 100%);

    ${media.w.greaterThanOrEqual.desktop} {
      right: -83px;
    }
  }
`;

const Heading = styled.h1`
  font-size: 24px;
  font-weight: 300;
  line-height: 29px;
  color: ${fromTheme((theme) => theme.text.palette.accent)};
  text-transform: uppercase;
  margin-bottom: 24px;

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 32px;
    font-weight: 300;
    line-height: 32px;
    letter-spacing: 0.02em;
    margin-bottom: 29px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  color: ${fromTheme((theme) => theme.text.palette.gray3)};
  margin-bottom: 36px;

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  }

  ${media.w.lessThan.desktop} {
    max-width: 270px;
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;

  ${media.w.lessThan.desktop} {
    left: 35px;
  }
`;

interface ProductsNeedleSegmentProps {
  heading: string;
  description: string;
}

export const ProductsNeedleSegment: FC<ProductsNeedleSegmentProps> = ({
  heading,
  description,
}) => {
  const { _ } = useTranslate();

  return (
    <Container>
      <Needle />
      <div>
        <Heading>{_(heading)}</Heading>
        <Description>
          <Markdown>{_(description)}</Markdown>
        </Description>
      </div>
    </Container>
  );
};
